<template>
  <span>
    <el-tooltip placement="top">
      <div slot="content" class="tooltip-content">
        <p v-for="val in tooltipContent" :key="val">{{ val }}</p>
      </div>
      <!-- v-if="showBadge"不能加载最外层元素上，否则会导致不显示tooltip -->
      <span>
        <span v-if="showBadge" class="badge-content" @click="showBadge = false">{{
          showNum || tooltipContent.length
        }}</span>
      </span>
    </el-tooltip>
  </span>
</template>

<script>
const dateFormat = require('dateformat')

const stepMap = {
  职位推荐: '已推荐',
  面试阶段: '面试',
  offer谈判: 'offer',
  离职管理: '到岗',
}
const mapObj = {
  职位JD: ['岗位职责', '岗位要求'],
  客户信息: ['核心要求', '面试流程', '关键面试人', '对接hr', '客户特殊要求'],
  寻访方向: ['寻访方向', '目标公司', '典型目标人选'],
  亮点优势: ['职位亮点及优势', '部门详情', '阿尔法认知'],
  人才画像: ['职能模块', '擅长方向', '目标行业', '平台', '职级', '业绩', '地域'],
}
const projectFields = []
Object.keys(mapObj).forEach(v => {
  projectFields.push(...mapObj[v])
})

export default {
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
    days: { type: Number, default: 0 },
    getPipeline: { type: Boolean, default: false },
  },
  data() {
    return {
      tooltipContent: [],
      showNum: 0,
      showBadge: false,
    }
  },
  watch: {
    getPipeline(newValue, oldValue) {
      if (newValue === true) this.init()
    },
  },

  methods: {
    init() {
      this.account = app.user.account
      if (this.step === '项目创建') {
        this.checkXmcjBadge()
      } else if (this.step === '职位推荐') {
        this.checkRcsxBadge()
      } else if (this.step === '面试阶段') {
        this.checkMsjdBadge()
      } else if (this.step === 'offer谈判') {
        this.checkOfferBadge()
      } else if (this.step === '离职管理') {
        this.checkLzglBadge()
      } else if (this.step === '开票催款') {
        this.checkKpckBadge()
      }
    },
    getStorage(name) {
      const { project } = this
      const storage = localStorage.getItem(name)
      const obj = (storage && JSON.parse(storage)) || {}
      const projectStorage = obj[project._id] || {}
      return projectStorage
    },
    getOtherStorage(name) {
      const storage = localStorage.getItem(name)
      const obj = (storage && JSON.parse(storage)) || {}
      return obj
    },
    // 项目创建
    checkXmcjBadge() {
      const projectStorage = this.getStorage('projectHistory')
      const newProjectHistory = this.project.修改历史 || {}
      const result = []
      for (const label in mapObj) {
        const fields = mapObj[label]
        const tempObj = { 新增: 0 }
        // eslint-disable-next-line no-loop-func
        fields.forEach(field => {
          // 判断是否是本人修改的，不是才算数
          // if (newProjectHistory[field] && newProjectHistory[field].updatedBy !== account) {
          if (JSON.stringify(newProjectHistory[field] || {}) !== JSON.stringify(projectStorage[field] || {})) {
            tempObj.新增 += 1
          }
          // }
        })
        if (tempObj.新增 > 0) result.push(`【 ${label}新增项目信息 】`)
      }
      this.tooltipContent = result
      if (result.length > 0) {
        this.showBadge = true
        this.showNum = result.length
      }
    },
    // 人才搜寻
    async checkRcsxBadge() {
      const { project, account, step } = this
      const fieldMap = {
        职位推荐: '客户经理人选反馈',
        面试阶段: '客户对项目反馈',
        offer谈判: '项目offer反馈',
      }
      const field = fieldMap[step]
      if (!field) return

      const projectStorage = this.getStorage('projectHistory')
      const recommends = this.project.recommends || []
      const feedbacks = project[field] || []
      const oldFeedbacks = projectStorage[field] || []

      const result = []
      let showNum = 0
      feedbacks.forEach(val => {
        // 判断填写此条数据的不是当前用户，同时历史查记录中不包含此条数据的，如果为true，说明有更新，需要显示红点
        const flag = val.user !== account && !oldFeedbacks.find(v => JSON.stringify(v) === JSON.stringify(val))
        if (flag && result.length === 0) result.push(`【 客户反馈请查看 】`)
      })
      if (result.length > 0) showNum = 1

      const radishProjectStorage = this.getOtherStorage('radishProjectHistory')
      const recommendStorage = this.getOtherStorage('recommendHistory')
      const list = await this.getList()
      const names = []
      const managerFeedbackNames = []
      const radishFeedbackNames = []

      list.forEach(val => {
        const name = val.radish && val.radish.姓名
        if (
          JSON.stringify(val[`修改历史`] || {}) !== JSON.stringify(radishProjectStorage[`${val.pid}${val.rid}`] || {})
        ) {
          if (name) names.push(name)
        }
        // 判断反馈
        const recommend = recommends.find(v => v.rid === val.rid)
        const recommendFeedbacks = (recommend && recommend.推荐反馈) || []
        const arr = (recommend&& recommendStorage[recommend._id]) || []
        recommendFeedbacks.sort((a, b) => a.时间 - b.时间)
        const managerFeedback = recommendFeedbacks.filter(v => v.类型 === '客户经理')
        const radishFeedback = recommendFeedbacks.filter(v => v.类型 === '候选人')
        managerFeedback.forEach(v => {
          // 查找填写数据的是当前用户，或者历史查记录中是否包含此条数据的，如果找到，说明不用显示红点
          const flag = v.顾问 !== account && !arr.find(x => JSON.stringify(x) === JSON.stringify(v))
          if (flag && name) managerFeedbackNames.push(name)
        })
        radishFeedback.forEach(v => {
          // 查找填写数据的是当前用户，或者历史查记录中是否包含此条数据的，如果找到，说明不用显示红点
          const flag = v.顾问 !== account && !arr.find(x => JSON.stringify(x) === JSON.stringify(v))
          if (flag && name) radishFeedbackNames.push(name)
        })
      })
      if (names.length > 0) {
        result.push(`【 推荐${names.join('、')}请查看 】`)
        showNum += names.length
      }
      if (managerFeedbackNames.length > 0) {
        result.push(`【 客户对${managerFeedbackNames.join('、')}反馈请查看 】`)
        showNum += managerFeedbackNames.length
      }
      if (radishFeedbackNames.length > 0) {
        result.push(`【 ${radishFeedbackNames.join('、')}反馈请查看 】`)
        showNum += radishFeedbackNames.length
      }
      this.tooltipContent = result
      this.showNum = showNum
      if (this.showNum > 0) this.showBadge = true
    },
    // 面试阶段
    async checkMsjdBadge() {
      const { project, account, step } = this
      const fieldMap = {
        职位推荐: '客户经理人选反馈',
        面试阶段: '客户对项目反馈',
        offer谈判: '项目offer反馈',
      }
      const field = fieldMap[step]
      if (!field) return

      const projectStorage = this.getStorage('projectHistory')
      const interviews = this.project.interviews || []
      const feedbacks = project[field] || []
      const oldFeedbacks = projectStorage[field] || []

      const result = []
      let showNum = 0
      feedbacks.forEach(val => {
        // 判断填写此条数据的不是当前用户，同时历史查记录中不包含此条数据的，如果为true，说明有更新，需要显示红点
        const flag = val.user !== account && !oldFeedbacks.find(v => JSON.stringify(v) === JSON.stringify(val))
        if (flag && result.length === 0) result.push(`【 客户反馈请查看 】`)
      })
      if (result.length > 0) showNum = 1

      const radishProjectStorage = this.getOtherStorage('radishProjectHistory')
      const interviewHistory = this.getOtherStorage('interviewHistory')
      const list = await this.getList()
      const names = []
      const managerFeedbackNames = []
      const radishFeedbackNames = []

      list.forEach(val => {
        const name = val.radish && val.radish.姓名
        if (
          JSON.stringify(val[`修改历史`] || {}) !== JSON.stringify(radishProjectStorage[`${val.pid}${val.rid}`] || {})
        ) {
          if (name) names.push(name)
        }
        // 判断反馈
        const radishInterviews = interviews.filter(v => v.rid === val.rid)
        const interviewFeedbacks = []
        radishInterviews.forEach(v => {
          if (v.面试反馈) interviewFeedbacks.push(...v.面试反馈)
        })

        const arr = interviewHistory[`${val.pid}${val.rid}`] || []
        interviewFeedbacks.sort((a, b) => a.时间 - b.时间)
        const managerFeedback = interviewFeedbacks.filter(v => v.类型 === '客户经理')
        const radishFeedback = interviewFeedbacks.filter(v => v.类型 === '候选人')
        managerFeedback.forEach(v => {
          // 查找填写数据的是当前用户，或者历史查记录中是否包含此条数据的，如果找到，说明不用显示红点
          const flag = v.顾问 !== account && !arr.find(x => JSON.stringify(x) === JSON.stringify(v))
          if (flag && name) managerFeedbackNames.push(name)
        })
        radishFeedback.forEach(v => {
          // 查找填写数据的是当前用户，或者历史查记录中是否包含此条数据的，如果找到，说明不用显示红点
          const flag = v.顾问 !== account && !arr.find(x => JSON.stringify(x) === JSON.stringify(v))
          if (flag && name) radishFeedbackNames.push(name)
        })
      })
      if (names.length > 0) {
        result.push(`【 ${names.join('、')}安排了面试请查看 】`)
        showNum += names.length
      }
      if (managerFeedbackNames.length > 0) {
        result.push(`【 客户对${this.arrRemoveDuplicate(managerFeedbackNames).join('、')}反馈请查看 】`)
        showNum += managerFeedbackNames.length
      }
      if (radishFeedbackNames.length > 0) {
        result.push(`【 ${this.arrRemoveDuplicate(radishFeedbackNames).join('、')}反馈请查看 】`)
        showNum += radishFeedbackNames.length
      }
      this.tooltipContent = result
      this.showNum = showNum
      if (this.showNum > 0) this.showBadge = true
    },
    // offer谈判
    async checkOfferBadge() {
      const { project, account, step } = this
      const fieldMap = {
        职位推荐: '客户经理人选反馈',
        面试阶段: '客户对项目反馈',
        offer谈判: '项目offer反馈',
      }
      const field = fieldMap[step]
      if (!field) return

      const projectStorage = this.getStorage('projectHistory')
      const feedbacks = project[field] || []
      const oldFeedbacks = projectStorage[field] || []

      const result = []
      let showNum = 0
      feedbacks.forEach(val => {
        // 判断填写此条数据的不是当前用户，同时历史查记录中不包含此条数据的，如果为true，说明有更新，需要显示红点
        const flag = val.user !== account && !oldFeedbacks.find(v => JSON.stringify(v) === JSON.stringify(val))
        if (flag && result.length === 0) result.push(`【 项目offer反馈请查看 】`)
      })
      if (result.length > 0) showNum = 1

      const radishProjectStorage = this.getOtherStorage('radishProjectHistory')
      const radishProgressHistory = this.getOtherStorage('radishProgressHistory')
      const list = await this.getListComplete()
      const managerFeedbackNames = []
      const radishFeedbackNames = []
      const finalInterviewNames = []
      const offerMaybeNames = []

      list.forEach(val => {
        const name = val.radish && val.radish.姓名
        if (
          JSON.stringify(val[`修改历史`] || {}) !== JSON.stringify(radishProjectStorage[`${val.pid}${val.rid}`] || {})
        ) {
          if (name) val.状态.tag === '面试' ? finalInterviewNames.push(name) : offerMaybeNames.push(name)
        }

        const time = radishProgressHistory[`${val.pid}${val.rid}`]
        const timestamp = time ? new Date(time).getTime() : 0

        const offerFeedback = val.logs.find(v => v.type === 'offer反馈' && new Date(v.timestamp).getTime() > timestamp)
        const str = (offerFeedback && offerFeedback.more) || ''
        const arr = str.split('<br>')
        if (arr[1]) managerFeedbackNames.push(name)
        if (arr[3]) radishFeedbackNames.push(name)
      })

      if (finalInterviewNames.length > 0) {
        result.push(`【 ${finalInterviewNames.join('、')}终面请查看 】`)
        showNum += finalInterviewNames.length
      }
      if (offerMaybeNames.length > 0) {
        result.push(`【 ${offerMaybeNames.join('、')}拟offer请查看 】`)
        showNum += offerMaybeNames.length
      }
      if (managerFeedbackNames.length > 0) {
        result.push(`【 客户对${this.arrRemoveDuplicate(managerFeedbackNames).join('、')}反馈请查看 】`)
        showNum += managerFeedbackNames.length
      }
      if (radishFeedbackNames.length > 0) {
        result.push(`【 ${this.arrRemoveDuplicate(radishFeedbackNames).join('、')}对offer有反馈请查看 】`)
        showNum += radishFeedbackNames.length
      }
      this.tooltipContent = result
      this.showNum = showNum
      if (this.showNum > 0) this.showBadge = true
    },
    // 离职管理
    async checkLzglBadge() {
      const result = []
      let showNum = 0

      const radishProgressHistory = this.getOtherStorage('radishProgressHistory')
      const list = await this.getListComplete()

      const querenOfferNames = []
      const yixiangNames = []
      const muqianOfferNames = []
      const weiruzhiNames = []

      list.forEach(val => {
        const name = val.radish && val.radish.姓名
        const time = radishProgressHistory[`${val.pid}${val.rid}`]
        const timestamp = time ? new Date(time).getTime() : 0

        const queren = (val.logs || []).find(v => v.type === '确认offer' && new Date(v.timestamp).getTime() > timestamp)
        const lizhifudao = (val.logs || []).find(v => v.type === '离职辅导' && new Date(v.timestamp).getTime() > timestamp)
        const weiruzhi = (val.logs || []).find(v => v.type === '未入职' && new Date(v.timestamp).getTime() > timestamp)

        if (queren) querenOfferNames.push(name)
        if (lizhifudao) {
          const str = lizhifudao.more || ''
          const arr = str.split('<br>')
          if (arr[1]) yixiangNames.push(name)
          if (arr[3]) muqianOfferNames.push(name)
        }
        if (weiruzhi) weiruzhiNames.push(name)
      })

      if (querenOfferNames.length > 0) {
        result.push(`【 ${querenOfferNames.join('、')}确认offer，请查看 】`)
        showNum += querenOfferNames.length
      }
      if (yixiangNames.length > 0) {
        result.push(`【 ${yixiangNames.join('、')}对客户意向反馈，请查看 】`)
        showNum += yixiangNames.length
      }
      if (muqianOfferNames.length > 0) {
        result.push(`【 ${muqianOfferNames.join('、')}有其他机会在同步，请查看 】`)
        showNum += muqianOfferNames.length
      }
      if (weiruzhiNames.length > 0) {
        result.push(`【 ${weiruzhiNames.join('、')}未入职，请跟进 】`)
        showNum += weiruzhiNames.length
      }

      this.tooltipContent = result
      this.showNum = showNum
      if (this.showNum > 0) this.showBadge = true
    },
    // 开票催款
    async checkKpckBadge() {
      const result = []
      let showNum = 0

      const radishProgressHistory = this.getOtherStorage('radishProgressHistory')
      const list = await this.getListComplete()

      const daogangNames = []
      const guobaoNames = []
      const weiguobaoNames = []

      list.forEach(val => {
        const name = val.radish && val.radish.姓名
        const time = radishProgressHistory[`${val.pid}${val.rid}`]
        const timestamp = time ? new Date(time).getTime() : 0

        const daogang = (val.logs || []).find(v => v.type === '到岗' && new Date(v.timestamp).getTime() > timestamp)
        const guobao = (val.logs || []).find(v => v.type === '过保' && new Date(v.timestamp).getTime() > timestamp)
        const weiguobao = (val.logs || []).find(v => v.type === '未过保' && new Date(v.timestamp).getTime() > timestamp)

        if (daogang) daogangNames.push(name)
        if (guobao) guobaoNames.push(name)
        if (weiguobao) weiguobaoNames.push(name)
      })

      if (daogangNames.length > 0) {
        result.push(`【 ${daogangNames.join('、')}到岗，请查看 】`)
        showNum += daogangNames.length
      }
      if (guobaoNames.length > 0) {
        result.push(`【 ${guobaoNames.join('、')}过保，请催款 】`)
        showNum += guobaoNames.length
      }
      if (weiguobaoNames.length > 0) {
        result.push(`【 ${weiguobaoNames.join('、')}未过保，请跟进 】`)
        showNum += weiguobaoNames.length
      }

      this.tooltipContent = result
      this.showNum = showNum
      if (this.showNum > 0) this.showBadge = true
    },
    arrRemoveDuplicate(arr) {
      const setObj = new Set(arr)
      return [...setObj]
    },
    async getList() {
      const filterVal = stepMap[this.step]
      const radishProject = this.project.radish_project || []

      const list = radishProject.filter(
        v =>
          v.状态 &&
          v.状态.tag === filterVal &&
          (filterVal === '面试' ? v.状态.detail !== '终面' : true) &&
          v.状态.detail !== '淘汰' &&
          v.状态.detail !== '放弃',
      )
      if(!list.length) return []
      // const res = await app.service('radish').findByIds({ ids: list.map(item => item.rid) })
      // if (res.status === 'success') {
      //   list.forEach(ele => {
      //     ele.radish = res.data.find(v => v._id === ele.rid)
      //   })
      // }
      return list
    },
    async getListComplete() {
      const { step } = this
      const radishProject = this.project.radish_project || []

      let list = []
      if (step === 'offer谈判') {
        list = radishProject.filter(
          v =>
            v.状态 &&
            ((v.状态.tag === '面试' && v.状态.detail === '终面') || v.状态.tag === 'offer谈判') &&
            v.状态.detail !== '淘汰' &&
            v.状态.detail !== '放弃',
        )
      } else if (step === '离职管理') {
        list = radishProject.filter(
          v => v.状态 && v.状态.tag === 'offer' && v.状态.detail !== '淘汰' && v.状态.detail !== '放弃',
        )
      } else if (step === '开票催款') {
        list = radishProject.filter(
          v =>
            v.状态 && (v.状态.tag === '到岗' || (v.状态.tag === '过保' && !v.状态.detail)) && v.状态.detail !== '淘汰',
        )
      }
      if(!list.length) return []
      // const res = await app.service('radish').findByIds({ ids: list.map(item => item.rid) })
      // if (res.status === 'success') {
      //   list.forEach(ele => {
      //     ele.radish = res.data.find(v => v._id === ele.rid)
      //   })
      // }
      for (const row of list) {
        const logRes = await app.service('radish').getProgressLog({ rid: row.rid, pid: row.pid })
        row.logs = logRes.data || []
      }

      return list
    },
  },
}
</script>

<style scoped>
.badge-content {
  margin-left: 5px;
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
}
</style>
